import { parseString } from "xml2js"
import { render, h } from "preact"
import "focus-visible/dist/focus-visible.min"

// Composants
import { Done } from "./components/done.jsx"
import { NotFound } from "./components/notfound.jsx"
import { Wip } from "./components/wip.jsx"
import { Error } from "./components/error.jsx"
import { NotOrangeOrSosh } from "./components/notorangeorsosh.jsx"

function convertXMLtoJSON(content) {
  try {
    let jsonData = null
    content = content.replace(/\n/g, "") // retire les retours à ligne du xml pour éviter d'avoir des \n dans les data
    parseString(
      content,
      // https://www.npmjs.com/package/xml2js#options
      { explicitArray: false, mergeAttrs: true },
      (err, result) => {
        if (err) {
          throw err
        }
        jsonData = result.declaration
      }
    )
    return jsonData
  } catch (error) {
    console.error(error)
  }
}
function getReportContent(url) {
  return new Promise((resolve, reject) => {
    let fileUrl = url.endsWith('/') ? url.slice(0, -1) : url // retire le dernier / de l'url qui peut être présent dans le lien
    fileUrl = fileUrl.replace(/\//g, "_") + '.xml'

    if (process.env.NODE_ENV === 'production') {
      fileUrl = 'https://cdn.woopic.com/v1/AUTH_e408f19d19da4e889e4ba9d9a1470ef0/accessibilite/' + fileUrl
    }

    fetch(fileUrl)
      .then(response => {
        if (response.headers.get("content-type").includes("application/xml")) {
          resolve(response.text())
        } else {
          // Si le fichier n'existe pas, essayez de remonter d'un niveau dans l'URL
          const pos = url.lastIndexOf('/')
          if (pos !== -1) {
            getReportContent(url.substring(0, pos)).then(resolve).catch(reject)
          } else {
            reject()
          }
        }
      })
      .catch(error => {
        console.error('Erreur lors de la vérification de l\'existence du fichier:', error)
        reject(error)
      })
  })
}

// https://jira.si.fr.intraorange/browse/FTACCUEILV-3198
// Si title existant, compléter la propriété title avec le suffixe " (nouvelle fenêtre)"
// Si title inexistant, reprendre le libellé du lien pour alimenter la propriété title et la compléter du même suffixe" (nouvelle fenêtre)"
// Redonder la propriété title obtenue avec la propriété aria-label toujours avec le suffixe "... (nouvelle fenêtre)"
const accessibility = () => {
  const suffix = " " + "(nouvelle fenêtre)"

  document
    .querySelectorAll("body > .site-width a[target=_blank]")
    .forEach((blankLink) => {
      let attrTitle = blankLink.title
      let attrAria = blankLink.ariaLabel
      let attrText = blankLink.text
      attrText = attrText.trim() // remove linebreaks and extra spaces
      let textSuffix = attrText + suffix

      if (attrTitle == "") {
        blankLink.title = textSuffix
      } else {
        blankLink.title += suffix
      }

      if (attrAria == "" || attrAria == null) {
        blankLink.setAttribute("aria-label", textSuffix)
      } else {
        blankLink.ariaLabel += suffix
      }
    })
}

try {
  // récupère le paramètre url de l'URL
  const href = new URL(window.location.href)
  const page = href.searchParams.get("url") || ''

  // teste si le domaine est orange.fr ou sosh.fr
  if (page && !page.includes('orange.fr') && !page.includes('sosh.fr')) {
    document.body.id = "accessibility-not-orange-sosh"
    render(<NotOrangeOrSosh />, document.getElementById("content"))
  } else if (page.length === 0) {
    document.body.id = "accessibility-error"
    render(<NotFound url={page} />, document.getElementById("content"))
  } else {
    getReportContent(page)
      .then(result => {
        let data = convertXMLtoJSON(result)
        // Si la déclaration d'accessibilité n'existe pas
        if (data === null) {
          document.body.id = "accessibility-not-found" // ???
          render(<NotFound url={page} />, document.getElementById("content"))
        } else {
          // la déclaration d'accessibilité existe
          // on change le titre de la page
          if (data.title) {
            document.title = "Déclaration d'accessibilité : " + data.title
          }

          // on ajoute l'id de la page à l'élément body
          data.status = data.status.toLowerCase()
          document.body.id = "accessibility-" + data.status

          //data.status = "WIP" // for testing
          if (data.status === "done") {
            render(<Done {...data} />, document.getElementById("content"))
          } else if (data.status === "wip") {
            render(<Wip {...data} />, document.getElementById("content"))
          } else {
            document.body.id = "accessibility-error"
            render(<Error />, document.getElementById("content"))
          }
        }
      })
      .catch(error => {
        document.body.id = "accessibility-error"
        render(<NotFound url={page} />, document.getElementById("content"))
      })
  }
} catch (error) {
  console.error(error)
}
